export default {
  phone: '0', // 0 - 767
  tablet: '767px', // 768 - 1279
  desktop: '1279px', // 1280 - 1919
  desktopXl: '1919px', // 1920+
}
